module.exports = __webpack_public_path__ + "static/media/analytics-selected.5d9def36.svg";